/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetSocialConnectionsConnectionsForStationQueryResponse, WebAppGetSocialConnectionsConnectionsForStationPathParams, WebAppGetSocialConnectionsConnectionsForStationQueryParams } from "../models/WebAppGetSocialConnectionsConnectionsForStation";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetSocialConnectionsConnectionsForStation } from "../axios/webAppGetSocialConnectionsConnectionsForStation";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetSocialConnectionsConnectionsForStationQueryKey = (station: WebAppGetSocialConnectionsConnectionsForStationPathParams["station"], params: WebAppGetSocialConnectionsConnectionsForStationQueryParams = {}) => ["api-v2", { url: '/web-app/social-connections/:station', params: {station:station} }, ...(params ? [params] : [])] as const

export type WebAppGetSocialConnectionsConnectionsForStationQueryKey = ReturnType<typeof webAppGetSocialConnectionsConnectionsForStationQueryKey>

export function webAppGetSocialConnectionsConnectionsForStationQueryOptions(station: WebAppGetSocialConnectionsConnectionsForStationPathParams["station"], params?: WebAppGetSocialConnectionsConnectionsForStationQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetSocialConnectionsConnectionsForStationQueryKey(station, params)
        return queryOptions<WebAppGetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, WebAppGetSocialConnectionsConnectionsForStationQueryResponse, typeof queryKey>({
         enabled: !!(station),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetSocialConnectionsConnectionsForStation(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get connection states for a station (optional `platform` query filters to one platform)
 * {@link /web-app/social-connections/:station}
 */
export function useWebAppGetSocialConnectionsConnectionsForStation<TData = WebAppGetSocialConnectionsConnectionsForStationQueryResponse, TQueryData = WebAppGetSocialConnectionsConnectionsForStationQueryResponse, TQueryKey extends QueryKey = WebAppGetSocialConnectionsConnectionsForStationQueryKey>(station: WebAppGetSocialConnectionsConnectionsForStationPathParams["station"], params?: WebAppGetSocialConnectionsConnectionsForStationQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetSocialConnectionsConnectionsForStationQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetSocialConnectionsConnectionsForStationQueryKey(station, params)
         

         const query = useQuery({
          ...webAppGetSocialConnectionsConnectionsForStationQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}